export default __webpack_public_path__ + "static/media/FiraSans-Italic.87d02eb3.woff2";